<se-fe-page SeFeDataWidth="full">
  <se-fe-header seFePageHeader [seFeDataTitle]="'DISCOUNTS.ADD_DISCOUNT.title' | translate" size="750">
    <se-fe-icon-button seFeHeaderActions data-dd-action-name="Close Discount" tabindex="-1" [routerLink]="'/discounts'">
      <se-fe-icon
        seFeDataName="remove"
        seFeDataSize="700"
        [seFeDataAriaLabel]="'DISCOUNTS.ADD_DISCOUNT.close' | translate"></se-fe-icon>
    </se-fe-icon-button>
  </se-fe-header>

  <div seFePageContent class="discount-page-content">
    <app-discount-form [formMode]="'create'" [discount]="discount"></app-discount-form>
  </div>
</se-fe-page>
